// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Js_dict from "rescript/lib/es6/js_dict.js";
import * as Belt_Array from "rescript/lib/es6/belt_Array.js";
import * as Belt_Option from "rescript/lib/es6/belt_Option.js";
import * as FlagsTypes$LiteracyplanetClientFlags from "./FlagsTypes.res.mjs";

function inObj(obj, key) {
  return Belt_Option.getWithDefault(Js_dict.get(obj, key), false);
}

function inArray(items, item) {
  return Belt_Array.some(items, (function (i) {
                return i === item;
              }));
}

function hasFeature(features, feature) {
  return inObj(features, FlagsTypes$LiteracyplanetClientFlags.unleashFeatureToString(feature));
}

function hasFlagInState(state) {
  var hasSystemOveride = function (systemFlag, $$default) {
    return Belt_Option.getWithDefault(Js_dict.get(state.systemFlags, systemFlag), $$default);
  };
  var hasAx = inArray(state.userRoles, "admin") && (inArray(state.classicFlags, "school-product") || inArray(state.classicFlags, "teacher-product") && inArray(state.classicFlags, "plg"));
  var getFlag = function (flag) {
    if (typeof flag !== "object") {
      if (flag === "DeveloperTestingIpad") {
        return hasSystemOveride("DeveloperTestingIpad", hasFeature(state.features, flag));
      } else if (flag === "StudentHasWordFlyers") {
        return hasSystemOveride("StudentHasWordFlyers", hasFeature(state.features, flag));
      } else if (flag === "FeatBadges") {
        return hasSystemOveride("FeatBadges", hasFeature(state.features, flag));
      } else if (flag === "StudentHasArcade") {
        return hasSystemOveride("StudentHasArcade", hasFeature(state.features, flag));
      } else if (flag === "ProductStudentHasLiteracyCheck") {
        return hasSystemOveride("ProductStudentHasLiteracyCheck", hasFeature(state.features, flag));
      } else if (flag === "TeacherProductStarterAccess") {
        return hasSystemOveride("TeacherProductStarterAccess", inArray(state.classicFlags, "starter-access") && inArray(state.classicFlags, "teacher-product"));
      } else if (flag === "PLGProduct") {
        return hasSystemOveride("PLGProduct", inArray(state.classicFlags, "plg"));
      } else if (flag === "StudentIsStudentMode") {
        return hasSystemOveride("StudentIsStudentMode", inArray(state.classicFlags, "is-student-mode"));
      } else if (flag === "IsPlg") {
        return hasSystemOveride("IsPlg", inArray(state.classicFlags, "plg"));
      } else if (flag === "AuthFullAccess") {
        return hasSystemOveride("AuthFullAccess", inArray(state.classicFlags, "full-access"));
      } else if (flag === "CanAccessAx") {
        return hasSystemOveride("CanAccessAx", hasAx);
      } else if (flag === "StudentHasSecondary") {
        return hasSystemOveride("StudentHasSecondary", hasFeature(state.features, flag) || inArray(state.classicFlags, "secondary-ux"));
      } else if (flag === "InvoicedSchool") {
        return hasSystemOveride("InvoicedSchool", !inArray(state.classicFlags, "plg") && inArray(state.classicFlags, "school-product"));
      } else if (flag === "ProductTeacherHasLiteracyCheck") {
        return hasSystemOveride("ProductTeacherHasLiteracyCheck", hasFeature(state.features, flag));
      } else if (flag === "SchoolProductTrial") {
        return hasSystemOveride("SchoolProductTrial", inArray(state.classicFlags, "in-trial") && inArray(state.classicFlags, "full-access") && inArray(state.classicFlags, "school-product"));
      } else if (flag === "AuthProAccess") {
        return hasSystemOveride("AuthProAccess", inArray(state.classicFlags, "pro-access"));
      } else if (flag === "DeveloperTestingLocales") {
        return hasSystemOveride("DeveloperTestingLocales", hasFeature(state.features, flag));
      } else if (flag === "TrialAvailable") {
        return hasSystemOveride("TrialAvailable", inArray(state.classicFlags, "trial-available"));
      } else if (flag === "FeatStudentProfile") {
        return hasSystemOveride("FeatStudentProfile", hasFeature(state.features, flag));
      } else if (flag === "StudentCanAccessWM") {
        return hasSystemOveride("StudentCanAccessWM", inArray(state.classicFlags, "wm"));
      } else if (flag === "TeacherProductProAccess") {
        return hasSystemOveride("TeacherProductProAccess", inArray(state.classicFlags, "pro-access") && inArray(state.classicFlags, "teacher-product"));
      } else if (flag === "CanAccessWordFlyers") {
        return hasSystemOveride("CanAccessWordFlyers", inArray(state.classicFlags, "word-flyers"));
      } else if (flag === "InTrial") {
        return hasSystemOveride("InTrial", inArray(state.classicFlags, "in-trial"));
      } else if (flag === "IsAdmin") {
        return inArray(state.userRoles, "admin");
      } else if (flag === "LibraryProduct") {
        return hasSystemOveride("LibraryProduct", inArray(state.classicFlags, "library-product"));
      } else if (flag === "AccountIsProvisioned") {
        return hasSystemOveride("AccountIsProvisioned", inArray(state.classicFlags, "account-is-provisioned"));
      } else if (flag === "TeacherProductProTrial") {
        return hasSystemOveride("TeacherProductProTrial", (inArray(state.classicFlags, "pro-access-trial") || inArray(state.classicFlags, "in-trial") && inArray(state.classicFlags, "pro-access")) && inArray(state.classicFlags, "teacher-product"));
      } else if (flag === "DeveloperTestingLayouts") {
        return hasSystemOveride("DeveloperTestingLayouts", hasFeature(state.features, flag));
      } else if (flag === "FeatSxWordmaniaDisable") {
        return hasSystemOveride("FeatSxWordmaniaDisable", hasFeature(state.features, flag));
      } else if (flag === "StudentHasStoryverse") {
        return hasSystemOveride("StudentHasStoryverse", hasFeature(state.features, flag));
      } else if (flag === "SchoolProduct") {
        return hasSystemOveride("SchoolProduct", inArray(state.classicFlags, "school-product"));
      } else if (flag === "StudentCanUseLibrary") {
        return hasSystemOveride("StudentCanUseLibrary", hasFeature(state.features, flag));
      } else if (flag === "IsParent") {
        return hasSystemOveride("IsParent", inArray(state.userRoles, "parent"));
      } else if (flag === "FeatDynamicAvatarIds") {
        return hasSystemOveride("FeatDynamicAvatarIds", hasFeature(state.features, flag));
      } else if (flag === "AuthStarterAccess") {
        return hasSystemOveride("AuthStarterAccess", inArray(state.classicFlags, "starter-access"));
      } else if (flag === "CanAccessAxReports") {
        return hasSystemOveride("CanAccessAxReports", hasAx && inArray(state.classicFlags, "full-access"));
      } else if (flag === "FeatSocial") {
        return hasSystemOveride("FeatSocial", hasFeature(state.features, flag));
      } else if (flag === "TeacherCanManageTeachingGroups") {
        return hasSystemOveride("TeacherCanManageTeachingGroups", inArray(state.classicFlags, "teaching-groups"));
      } else if (flag === "FeatBuildTrophyCache") {
        return hasSystemOveride("FeatBuildTrophyCache", hasFeature(state.features, flag));
      } else if (flag === "TeacherProduct") {
        return hasSystemOveride("TeacherProduct", inArray(state.classicFlags, "teacher-product"));
      } else if (flag === "StudentHasLocking") {
        return hasSystemOveride("StudentHasLocking", hasFeature(state.features, flag));
      } else if (flag === "IsDeveloper") {
        return inArray(state.userRoles, "developer");
      } else if (flag === "HomeProduct") {
        return hasSystemOveride("HomeProduct", inArray(state.classicFlags, "home-product"));
      } else {
        return hasSystemOveride("DeveloperArcadeGames", hasFeature(state.features, flag));
      }
    }
    var variant = flag.NAME;
    if (variant !== "Classic") {
      if (variant === "Unleash") {
        return hasSystemOveride(flag.VAL, hasFeature(state.features, flag));
      } else {
        return inObj(state.systemFlags, flag.VAL);
      }
    }
    var f = flag.VAL;
    return hasSystemOveride(f, inArray(state.classicFlags, f));
  };
  var unsafeGetFlag = function (flag) {
    return getFlag(FlagsTypes$LiteracyplanetClientFlags.stringToFlag(flag));
  };
  return {
          getFlag: getFlag,
          unsafeGetFlag: unsafeGetFlag
        };
}

export {
  inObj ,
  inArray ,
  hasFeature ,
  hasFlagInState ,
}
/* No side effect */
